import {organizationSchema} from 'apis/schema'
import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import useTranslate from "../../../modules/local/useTranslate";
import classNames from "classnames";
import {renderIf, renderIfElse} from "../../Shared";
import {GoDotFill} from "react-icons/go";
import {getType} from "../../../apis/model/base";
import {BiSolidChurch} from "react-icons/bi";
import {BsPerson} from "react-icons/bs";
import {FaChalkboardTeacher} from "react-icons/fa";
import {RiAppsFill, RiSignalTowerFill} from "react-icons/ri";

const OrganizationEntity = ({
                                item,
                                children,
                                defaultItem,
                            }) => {
    return (
        <SelectEntityItem
            item={item}
            defaultItem={defaultItem}
            schema={organizationSchema}>
            {(data) => children(data)}
        </SelectEntityItem>
    )
}

export const ItemInformation = ({label, value, className = 'text-base italic', showIcon = false, colon = true, primary = false, style}) => {
    const t = useTranslate()
    return renderIf(
        value,
        <div style={style} className={classNames('space-x-1', className)}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={className ? 10 : 12} className="text-color-400"/>
            )}
            {renderIf(
                label,
                <span className="text-color-400 whitespace-no-wrap italic">
                    {colon ? `${t(label)}: ` : t(label)}
                </span>
            )}
            <span
                className={primary === true ? 'font-bold text-gray-800' : value ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
              {value ? value : t('not update')}
          </span>
        </div>
    )
}

export const DoubleValueItem = ({
                                    showIcon = false,
                                    primary = false,
                                    style,
                                    className = 'text-sm',
                                    iconFirst,
                                    labelFirst,
                                    valueFirst,
                                    iconSecond,
                                    labelSecond,
                                    valueSecond,
                                }) => {
    const t = useTranslate()

    return (
        <div style={style} className={classNames("space-x-1", className)}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={className ? 10 : 12} className="text-color-400"/>
            )}
            {renderIfElse(
                labelFirst,
                <span className="text-color-400 italic whitespace-no-wrap">
                    {`${t(labelFirst)}: `}
                </span>,
                iconFirst
            )}
            <span
                className={primary === true ? 'font-bold text-gray-800' : valueFirst ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
                {valueFirst || t('not update')}
            </span>
            {renderIfElse(
                labelSecond,
                <span
                    className="mx-1 text-color-400 italic whitespace-no-wrap">{t(labelSecond) || ''}</span>,
                iconSecond
            )}
            {renderIf(
                valueSecond,
                <span
                    className={primary === true ? 'font-bold text-gray-800' : valueSecond ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
                    {valueSecond || t('not update')}
                </span>
            )}
        </div>
    )
}

export const ItemInfoWithIcon = ({
                                     icon = <GoDotFill size={10} className="text-color-500"/>,
                                     value,
                                     className = 'text-base italic',
                                     primary = false,
                                 }) => {
    const t = useTranslate()
    return !!value && (
        <div className={classNames('space-x-1', className)}>
            {icon}
            <span className={primary === true ? 'font-bold text-gray-800' : value ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
              {value ? value : t('not update')}
          </span>
        </div>
    )
}

export const ItemInfoGrid = ({showIcon = false, center = false, label, value, className = 'text-base italic', primary = false}) => {
    const t = useTranslate()
    return (
        <div className={classNames('grid grid-cols-1 md:grid-cols-2 gap-x-1', className)}>
          <span className={classNames("text-color-400 whitespace-no-wrap italic", center === true && 'text-right')}>
              {renderIf(
                  showIcon === true,
                  <GoDotFill size={10} className="text-color-400 mr-1"/>
              )}
              {`${t(label)}: `}
          </span>
            <span
                className={primary === true ? 'font-bold text-gray-800' : value ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
              {value ? value : t('not update')}
          </span>
        </div>
    )
}

export const renderIconOwner = (item) => {

    let icon

    switch (getType(item?.owner)) {
        case "organization":
            icon = <BiSolidChurch size={12} className="text-color-500"/>
            break
        case 'user':
            icon = <BsPerson size={12} className="text-color-500"/>
            break
        case 'course':
            icon = <FaChalkboardTeacher size={12} className="text-color-500"/>
            break
        case 'channel':
            icon = <RiSignalTowerFill size={12} className="text-color-500"/>
            break
        default:
            icon = <RiAppsFill size={12} className="text-color-500"/>
            break
    }

    return icon
}

export const OrganizationEntities = ({
                                         items,
                                         children,
                                         defaultItem,
                                     }) => {
    return (
        <SelectEntityItem
            item={items}
            defaultItem={defaultItem}
            schema={[organizationSchema]}>
            {(data = []) =>
                children(
                    _.filter(data, notEmpty)
                )
            }
        </SelectEntityItem>
    )
}

export default OrganizationEntity
